import { lazy } from 'react';

/** Открывает форму шаблона промобаннера */
export const PromotionBannerTemplateFormPageAsync = lazy(() => import('./PromotionBannerTemplateFormPage'));
